// extracted by mini-css-extract-plugin
module.exports =  {"arrow":"vACAO80mElFl18dIiZlD","popper":"SCt7fCk4p9ylo40XG0k7","hasArrow":"jiJz0pLRRCXPNDKwxbe_","trigger":"Lecz56xv8yboQPnBQvpB"};